import { modes } from '../consts';
import type { DrawMode } from '../index';

export function getModeLabelText(mode: DrawMode, geometryType?: string): string {
  switch (mode) {
    case modes.DIRECT_SELECT:
      return geometryType != null ? `Modify ${geometryType}` : 'Modify';
    case modes.DRAW_POLYGON:
      return 'Draw Polygon';
    case modes.DRAW_LINE_STRING:
      return 'Draw Track';
    case modes.DRAW_POINT:
      return 'Add Point';
    case modes.POINT_ON_LINE_STRING:
      return 'Place Point on Track';
    case modes.EXPAND_LINE_STRING:
      return 'Expand Track';
    default:
      return 'Modify';
  }
}
